export enum VolopFunction {
  ACCOUNTING_FINANCE = 'ACCOUNTING_FINANCE',
  ADMINISTRATIVE_OFFICE_SUPPORT = 'ADMINISTRATIVE_OFFICE_SUPPORT',
  ADVOCACY = 'ADVOCACY',
  ANIMAL_CARE = 'ANIMAL_CARE',
  ANIMAL_THERAPY = 'ANIMAL_THERAPY',
  ARCHIVING_DATA_ENTRY = 'ARCHIVING_DATA_ENTRY',
  ART_THERAPY = 'ART_THERAPY',
  ARTS_CRAFTS = 'ARTS_CRAFTS',
  BOARD_COMMITTEE = 'BOARD_COMMITTEE',
  BUSINESS_DEVELOPMENT = 'BUSINESS_DEVELOPMENT',
  CASE_SOCIAL_WORK = 'CASE_SOCIAL_WORK',
  CHILD_CARE = 'CHILD_CARE',
  CHILD_DEVELOPMENT = 'CHILD_DEVELOPMENT',
  CHILD_WELFARE = 'CHILD_WELFARE',
  CITIZENSHIP = 'CITIZENSHIP',
  COMMUNICATIONS = 'COMMUNICATIONS',
  COMMUNITY_BELONGING = 'COMMUNITY_BELONGING',
  COMMUNITY_ENGAGEMENT_OUTREACH = 'COMMUNITY_ENGAGEMENT_OUTREACH',
  COMMUNITY_ORGANIZING = 'COMMUNITY_ORGANIZING',
  CONFLICT_RESOLUTION = 'CONFLICT_RESOLUTION',
  CONSERVATION = 'CONSERVATION',
  CONSTRUCTION_HOME_REPAIR = 'CONSTRUCTION_HOME_REPAIR',
  COUNSELING = 'COUNSELING',
  CORPORATE_PHILANTHROPY = 'CORPORATE_PHILANTHROPY',
  CORPORATE_RESPONSIBILITY = 'CORPORATE_RESPONSIBILITY',
  CRISIS_INTERVENTION = 'CRISIS_INTERVENTION',
  CUSTOMER_SERVICE = 'CUSTOMER_SERVICE',
  DANCE = 'DANCE',
  DATA_ANALYSIS = 'DATA_ANALYSIS',
  DATA_ENTRY = 'DATA_ENTRY',
  DATABASE_ADMINISTRATION = 'DATABASE_ADMINISTRATION',
  DESIGN = 'DESIGN',
  DIRECT_SERVICES = 'DIRECT_SERVICES',
  DISASTER_RELIEF = 'DISASTER_RELIEF',
  DIVERSITY_EQUITY_INCLUSION = 'DIVERSITY_EQUITY_INCLUSION',
  DONATION_DRIVE = 'DONATION_DRIVE',
  EDUCATION = 'EDUCATION',
  ELDER_CARE = 'ELDER_CARE',
  EMPLOYEE_ENGAGEMENT = 'EMPLOYEE_ENGAGEMENT',
  EQUIPMENT_FACILITIES = 'EQUIPMENT_FACILITIES',
  ESL = 'ESL',
  EVENT_SUPPORT = 'EVENT_SUPPORT',
  FARMING = 'FARMING',
  FOOD_DELIVERY_DISTRIBUTION = 'FOOD_DELIVERY_DISTRIBUTION',
  FOOD_SERVICE = 'FOOD_SERVICE',
  FUNDRAISING = 'FUNDRAISING',
  GARDENING = 'GARDENING',
  GRANTS_ADMINISTRATION = 'GRANTS_ADMINISTRATION',
  GRAPHIC_DESIGN = 'GRAPHIC_DESIGN',
  HABITAT_RESTORATION = 'HABITAT_RESTORATION',
  HEALTH_WELLNESS = 'HEALTH_WELLNESS',
  HEALTHCARE_PROVIDER_PRACTITIONER = 'HEALTHCARE_PROVIDER_PRACTITIONER',
  HOSPICE_CARE = 'HOSPICE_CARE',
  HUMAN_RESOURCES = 'HUMAN_RESOURCES',
  INVESTIGATIONS = 'INVESTIGATIONS',
  LANGUAGES = 'LANGUAGES',
  LEADERSHIP = 'LEADERSHIP',
  LEGAL = 'LEGAL',
  LOBBYING = 'LOBBYING',
  MARKETING = 'MARKETING',
  MASSAGE_THERAPY = 'MASSAGE_THERAPY',
  MENTOR_TUTOR = 'MENTOR_TUTOR',
  MUSIC = 'MUSIC',
  MUSIC_THERAPY = 'MUSIC_THERAPY',
  NETWORKING = 'NETWORKING',
  NURSING = 'NURSING',
  OPERATIONS = 'OPERATIONS',
  PARTNERSHIPS = 'PARTNERSHIPS',
  PATIENT_CARE = 'PATIENT_CARE',
  PEOPLE_SKILLS = 'PEOPLE_SKILLS',
  PHOTOGRAPHY = 'PHOTOGRAPHY',
  PHYSICAL_SERVICE = 'PHYSICAL_SERVICE',
  PROBLEM_SOLVING = 'PROBLEM_SOLVING',
  PROGRAM_MANAGEMENT = 'PROGRAM_MANAGEMENT',
  PROJECT_MANAGEMENT = 'PROJECT_MANAGEMENT',
  PROJECT_RESEARCH_STUDY = 'PROJECT_RESEARCH_STUDY',
  PUBLIC_HEALTH = 'PUBLIC_HEALTH',
  PUBLIC_RELATIONS = 'PUBLIC_RELATIONS',
  PUBLIC_SPEAKING = 'PUBLIC_SPEAKING',
  READING_WRITING = 'READING_WRITING',
  RELATIONSHIP_BUILDING = 'RELATIONSHIP_BUILDING',
  RESEARCH = 'RESEARCH',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  SPORTS_FITNESS_COACHING = 'SPORTS_FITNESS_COACHING',
  STEM = 'STEM',
  STRATEGIC_PLANNING = 'STRATEGIC_PLANNING',
  SUSTAINABILITY = 'SUSTAINABILITY',
  TEACHING_AND_INSTRUCTION = 'TEACHING_AND_INSTRUCTION',
  TECHNOLOGY_SUPPORT_WEB_DESIGN = 'TECHNOLOGY_SUPPORT_WEB_DESIGN',
  THEATER = 'THEATER',
  VETERAN_CARE = 'VETERAN_CARE',
  VIDEOGRAPHY = 'VIDEOGRAPHY',
  VISUAL_ARTS = 'VISUAL_ARTS',
  VOLUNTEER_COORDINATION = 'VOLUNTEER_COORDINATION',
  WRITING_EDITORIAL = 'WRITING_EDITORIAL',
  WRITING_JOURNALISM = 'WRITING_JOURNALISM',
  YOUTH_SERVICES = 'YOUTH_SERVICES',
}

export const VOLOP_FUNCTIONS = Object.defineProperties(
  {},
  {
    [VolopFunction.ACCOUNTING_FINANCE]: {
      get: () => getText('Accounting & Finance'),
      enumerable: true,
    },
    [VolopFunction.ADMINISTRATIVE_OFFICE_SUPPORT]: {
      get: () => getText('Administrative'),
      enumerable: true,
    },
    [VolopFunction.ADVOCACY]: {
      get: () => getText('Advocacy'),
      enumerable: true,
    },
    [VolopFunction.ANIMAL_CARE]: {
      get: () => getText('Animal Care'),
      enumerable: true,
    },
    [VolopFunction.ANIMAL_THERAPY]: {
      get: () => getText('Animal Therapy'),
      enumerable: true,
    },
    [VolopFunction.ARCHIVING_DATA_ENTRY]: {
      get: () => getText('Archiving/Data Entry'),
      enumerable: true,
    },
    [VolopFunction.ART_THERAPY]: {
      get: () => getText('Art Therapy'),
      enumerable: true,
    },
    [VolopFunction.ARTS_CRAFTS]: {
      get: () => getText('Arts & Crafts'),
      enumerable: true,
    },
    [VolopFunction.BOARD_COMMITTEE]: {
      get: () => getText('Board/Committee'),
      enumerable: true,
    },
    [VolopFunction.BUSINESS_DEVELOPMENT]: {
      get: () => getText('Business Development'),
      enumerable: true,
    },
    [VolopFunction.CASE_SOCIAL_WORK]: {
      get: () => getText('Case / Social Work'),
      enumerable: true,
    },
    [VolopFunction.CHILD_CARE]: {
      get: () => getText('Child Care'),
      enumerable: true,
    },
    [VolopFunction.CHILD_DEVELOPMENT]: {
      get: () => getText('Child Development'),
      enumerable: true,
    },
    [VolopFunction.CHILD_WELFARE]: {
      get: () => getText('Child Welfare'),
      enumerable: true,
    },
    [VolopFunction.CITIZENSHIP]: {
      get: () => getText('Citizenship'),
      enumerable: true,
    },
    [VolopFunction.COMMUNICATIONS]: {
      get: () => getText('Communications'),
      enumerable: true,
    },
    [VolopFunction.COMMUNITY_BELONGING]: {
      get: () => getText('Community Belonging'),
      enumerable: true,
    },
    [VolopFunction.COMMUNITY_ENGAGEMENT_OUTREACH]: {
      get: () => getText('Community Engagement / Outreach'),
      enumerable: true,
    },
    [VolopFunction.COMMUNITY_ORGANIZING]: {
      get: () => getText('Community Organizing'),
      enumerable: true,
    },
    [VolopFunction.CONFLICT_RESOLUTION]: {
      get: () => getText('Conflict Resolution'),
      enumerable: true,
    },
    [VolopFunction.CONSERVATION]: {
      get: () => getText('Conservation'),
      enumerable: true,
    },
    [VolopFunction.CONSTRUCTION_HOME_REPAIR]: {
      get: () => getText('Construction / Home Repair'),
      enumerable: true,
    },
    [VolopFunction.COUNSELING]: {
      get: () => getText('Counseling'),
      enumerable: true,
    },
    [VolopFunction.CORPORATE_PHILANTHROPY]: {
      get: () => getText('Corporate Philanthropy'),
      enumerable: true,
    },
    [VolopFunction.CORPORATE_RESPONSIBILITY]: {
      get: () => getText('Corporate Responsibility'),
      enumerable: true,
    },
    [VolopFunction.CRISIS_INTERVENTION]: {
      get: () => getText('Crisis Intervention'),
      enumerable: true,
    },
    [VolopFunction.CUSTOMER_SERVICE]: {
      get: () => getText('Customer Service'),
      enumerable: true,
    },
    [VolopFunction.DANCE]: {
      get: () => getText('Dance'),
      enumerable: true,
    },
    [VolopFunction.DATA_ANALYSIS]: {
      get: () => getText('Data Analysis'),
      enumerable: true,
    },
    [VolopFunction.DATA_ENTRY]: {
      get: () => getText('Data Entry'),
      enumerable: true,
    },
    [VolopFunction.DATABASE_ADMINISTRATION]: {
      get: () => getText('Database Administration'),
      enumerable: true,
    },
    [VolopFunction.DESIGN]: { get: () => getText('Design'), enumerable: true },
    [VolopFunction.DIRECT_SERVICES]: {
      get: () => getText('Direct Services'),
      enumerable: true,
    },
    [VolopFunction.DISASTER_RELIEF]: {
      get: () => getText('Disaster Relief'),
      enumerable: true,
    },
    [VolopFunction.DIVERSITY_EQUITY_INCLUSION]: {
      get: () => getText('Diversity, Equity & Inclusion'),
      enumerable: true,
    },
    [VolopFunction.DONATION_DRIVE]: {
      get: () => getText('Donation Drive'),
      enumerable: true,
    },
    [VolopFunction.EDUCATION]: {
      get: () => getText('Education'),
      enumerable: true,
    },
    [VolopFunction.ELDER_CARE]: {
      get: () => getText('Elder Care'),
      enumerable: true,
    },
    [VolopFunction.EMPLOYEE_ENGAGEMENT]: {
      get: () => getText('Employee Engagement'),
      enumerable: true,
    },
    [VolopFunction.EQUIPMENT_FACILITIES]: {
      get: () => getText('Equipment Facilities'),
      enumerable: true,
    },
    [VolopFunction.ESL]: {
      get: () => getText('English As Second Language (ESL)'),
      enumerable: true,
    },
    [VolopFunction.EVENT_SUPPORT]: {
      get: () => getText('Event Support / Management'),
      enumerable: true,
    },
    [VolopFunction.FARMING]: {
      get: () => getText('Farming'),
      enumerable: true,
    },
    [VolopFunction.FOOD_DELIVERY_DISTRIBUTION]: {
      get: () => getText('Food Delivery / Distribution'),
      enumerable: true,
    },
    [VolopFunction.FOOD_SERVICE]: {
      get: () => getText('Food / Beverage Service'),
      enumerable: true,
    },
    [VolopFunction.FUNDRAISING]: {
      get: () => getText('Development / Fundraising'),
      enumerable: true,
    },
    [VolopFunction.GARDENING]: {
      get: () => getText('Gardening'),
      enumerable: true,
    },
    [VolopFunction.GRANTS_ADMINISTRATION]: {
      get: () => getText('Grants Administration'),
      enumerable: true,
    },
    [VolopFunction.GRAPHIC_DESIGN]: {
      get: () => getText('Graphic Design'),
      enumerable: true,
    },
    [VolopFunction.HABITAT_RESTORATION]: {
      get: () => getText('Habitat Restoration'),
      enumerable: true,
    },
    [VolopFunction.HEALTH_WELLNESS]: {
      get: () => getText('Health & Wellness'),
      enumerable: true,
    },
    [VolopFunction.HEALTHCARE_PROVIDER_PRACTITIONER]: {
      get: () => getText('Health Provider / Practitioner'),
      enumerable: true,
    },
    [VolopFunction.HOSPICE_CARE]: {
      get: () => getText('Hospice Care'),
      enumerable: true,
    },
    [VolopFunction.HUMAN_RESOURCES]: {
      get: () => getText('Human Resources'),
      enumerable: true,
    },
    [VolopFunction.INVESTIGATIONS]: {
      get: () => getText('Investigations'),
      enumerable: true,
    },
    [VolopFunction.LANGUAGES]: {
      get: () => getText('Languages'),
      enumerable: true,
    },
    [VolopFunction.LEADERSHIP]: {
      get: () => getText('Leadership'),
      enumerable: true,
    },
    [VolopFunction.LEGAL]: { get: () => getText('Legal'), enumerable: true },
    [VolopFunction.LOBBYING]: {
      get: () => getText('Lobbying'),
      enumerable: true,
    },
    [VolopFunction.MARKETING]: {
      get: () => getText('Marketing'),
      enumerable: true,
    },
    [VolopFunction.MASSAGE_THERAPY]: {
      get: () => getText('Massage Therapy'),
      enumerable: true,
    },
    [VolopFunction.MENTOR_TUTOR]: {
      get: () => getText('Mentor/Tutor'),
      enumerable: true,
    },
    [VolopFunction.MUSIC]: { get: () => getText('Music'), enumerable: true },
    [VolopFunction.MUSIC_THERAPY]: {
      get: () => getText('Music Therapy'),
      enumerable: true,
    },
    [VolopFunction.NETWORKING]: {
      get: () => getText('Metworking'),
      enumerable: true,
    },
    [VolopFunction.NURSING]: {
      get: () => getText('Nursing'),
      enumerable: true,
    },
    [VolopFunction.OPERATIONS]: {
      get: () => getText('Operations'),
      enumerable: true,
    },
    [VolopFunction.PARTNERSHIPS]: {
      get: () => getText('Partnerships'),
      enumerable: true,
    },
    [VolopFunction.PATIENT_CARE]: {
      get: () => getText('Patient Care'),
      enumerable: true,
    },
    [VolopFunction.PEOPLE_SKILLS]: {
      get: () => getText('People Skills'),
      enumerable: true,
    },
    [VolopFunction.PHOTOGRAPHY]: {
      get: () => getText('Photography'),
      enumerable: true,
    },
    [VolopFunction.PHYSICAL_SERVICE]: {
      get: () => getText('Physical Service (Painting, Farming, etc.)'),
      enumerable: true,
    },
    [VolopFunction.PROBLEM_SOLVING]: {
      get: () => getText('Problem Solving'),
      enumerable: true,
    },
    [VolopFunction.PROGRAM_MANAGEMENT]: {
      get: () => getText('Program Management'),
      enumerable: true,
    },
    [VolopFunction.PROJECT_MANAGEMENT]: {
      get: () => getText('Project Management'),
      enumerable: true,
    },
    [VolopFunction.PROJECT_RESEARCH_STUDY]: {
      get: () => getText('Project or Research Study'),
      enumerable: true,
    },
    [VolopFunction.PUBLIC_HEALTH]: {
      get: () => getText('Public Health'),
      enumerable: true,
    },
    [VolopFunction.PUBLIC_RELATIONS]: {
      get: () => getText('Public Relations'),
      enumerable: true,
    },
    [VolopFunction.PUBLIC_SPEAKING]: {
      get: () => getText('Public Speaking'),
      enumerable: true,
    },
    [VolopFunction.READING_WRITING]: {
      get: () => getText('Reading / Writing'),
      enumerable: true,
    },
    [VolopFunction.RELATIONSHIP_BUILDING]: {
      get: () => getText('Relationship Building'),
      enumerable: true,
    },
    [VolopFunction.RESEARCH]: {
      get: () => getText('Research'),
      enumerable: true,
    },
    [VolopFunction.SOCIAL_MEDIA]: {
      get: () => getText('Social Media'),
      enumerable: true,
    },
    [VolopFunction.SPORTS_FITNESS_COACHING]: {
      get: () => getText('Sports & Fitness/Coaching'),
      enumerable: true,
    },
    [VolopFunction.STEM]: {
      get: () => getText('STEM'),
      enumerable: true,
    },
    [VolopFunction.STRATEGIC_PLANNING]: {
      get: () => getText('Strategic Planning'),
      enumerable: true,
    },
    [VolopFunction.SUSTAINABILITY]: {
      get: () => getText('Sustainability'),
      enumerable: true,
    },
    [VolopFunction.TEACHING_AND_INSTRUCTION]: {
      get: () => getText('Teaching & Instruction'),
      enumerable: true,
    },
    [VolopFunction.TECHNOLOGY_SUPPORT_WEB_DESIGN]: {
      get: () => getText('Web Design'),
      enumerable: true,
    },
    [VolopFunction.THEATER]: {
      get: () => getText('Theater'),
      enumerable: true,
    },
    [VolopFunction.VETERAN_CARE]: {
      get: () => getText('Veteran Care'),
      enumerable: true,
    },
    [VolopFunction.VIDEOGRAPHY]: {
      get: () => getText('Videography'),
      enumerable: true,
    },
    [VolopFunction.VISUAL_ARTS]: {
      get: () => getText('Visual Arts'),
      enumerable: true,
    },
    [VolopFunction.VOLUNTEER_COORDINATION]: {
      get: () => getText('Volunteer Coordination'),
      enumerable: true,
    },
    [VolopFunction.WRITING_EDITORIAL]: {
      get: () => getText('Writing Editorial'),
      enumerable: true,
    },
    [VolopFunction.WRITING_JOURNALISM]: {
      get: () => getText('Writing Journalism'),
      enumerable: true,
    },
    [VolopFunction.YOUTH_SERVICES]: {
      get: () => getText('Youth Services'),
      enumerable: true,
    },
  },
) as Record<VolopFunction, string>;

export const VOLOP_FUNCTION_CHECKBOX_OPTIONS = () =>
  Object.entries(VOLOP_FUNCTIONS).map(([key, value]) => ({
    name: key,
    label: value,
  }));

export const VOLOP_FUNCTION_RADIO_OR_SELECT_OPTIONS = () =>
  Object.entries(VOLOP_FUNCTIONS).map(([key, value]) => ({
    value: key,
    label: value,
  }));
